package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.data.model.UserProgress
import kotlinx.serialization.json.Json

private val progressJson = Json { ignoreUnknownKeys = true }
private const val KEY_USER_PROGRESS = "user_progress"

class SettingsProgressStore(
    private val settings: Settings,
) : ProgressStore {
    override fun load(): UserProgress {
        val raw = settings.getStringOrNull(KEY_USER_PROGRESS) ?: return UserProgress()
        return runCatching { progressJson.decodeFromString(UserProgress.serializer(), raw) }
            .getOrDefault(UserProgress())
    }

    override fun save(progress: UserProgress) {
        settings.putString(KEY_USER_PROGRESS, progressJson.encodeToString(UserProgress.serializer(), progress))
    }
}
